import React from 'react';
import { View } from 'react-native';
import Label from '../../Label';

interface IProps {
  isAutoMoto?: boolean;
  isHabitation?: boolean;
  isFamille?: boolean;
}

const Header = ({ isAutoMoto, isHabitation, isFamille }: IProps) => {
  let primaryTitle = 'ACCIDENT ET VOYAGE';
  let secondTitle =
    'Pour déclarer un sinistre accident et voyage, veuillez remplir les champs suivants';

  if (isAutoMoto) {
    primaryTitle = 'AUTO-MOTO';
    secondTitle =
      'Pour déclarer un sinistre auto-moto, veuillez remplir les champs suivants';
  } else if (isHabitation) {
    primaryTitle = 'HABITATION';
    secondTitle =
      'Pour déclarer un sinistre habitation, veuillez remplir les champs suivants';
  } else if (isFamille) {
    primaryTitle = 'FAMILLE';
    secondTitle =
      'Pour déclarer un sinistre Famille, veuillez remplir les champs suivants';
  }

  return (
    <View>
      <Label title={primaryTitle} type="mainTitle" />
      <Label title={secondTitle} type="secondTitle" />
    </View>
  );
};

export default Header;
